@if (this.productCategory$ | async; as productCategory) {
  <div
    class="tab-pane fade flex-even active show"
    id="claimTypes"
    role="tabpanel"
    aria-labelledby="claimTypes-tab"
  >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-12 col-md">
          @if (productCategory.claimTypes && productCategory.claimTypes.length > 0) {
            <app-generic-grid
              style="height: 300px"
              [data]="productCategory.claimTypes"
              [tabViewName]="'claimTypes'"
            />
          } @else {
            <p class="text-muted" translate>
              PRODUCT_CATEGORY_LBL_CLAIM_TYPE_EMPTY
            </p>
          }
        </div>
      </div>
    </div>
  </div>
}
